import { Button, Typography, Paper } from "@material-ui/core";
import { useEffect } from "react";
import { createMarkup } from "../helpers";

const TotalResults = ({
  classes,
  processedAnswers,
  finalScore,
  quizResults,
  translationString
}) => {
  useEffect(() => {
    window.scrollTo(0, "20px");
  }, []);

  const getPerc= (punt) => {
    let perc = (punt * 100) / 6;
    perc = Math.round(perc * 100) / 100
    return perc;
  };
  
  return (
    <div className={classes.results}>
      <Typography variant="h1" className={classes.mainTitle}>
        {translationString.title}
      </Typography>

      <Paper className={classes.paperResult}>
        <div>
          <p className={classes.resultsFeedbackDescription}>{translationString.result_description_1}</p>
          <p className={classes.resultsFeedbackDescription}>{translationString.result_description_2}</p>
        </div>
      </Paper>
      <Typography variant="h3" className={classes.subTitleResult}>
        {translationString.score_global}
      </Typography>
      <Paper className={classes.paperResult}>
        {finalScore > 69 ? 
            <div>
              <div className={classes.resultsFeedback}>
                <span className={classes.resultsFeedbackHighlighted}>{translationString.global_result_strings.high.label} {finalScore}%</span>{translationString.global_result_strings.high.message}
              </div>
              <p className={classes.resultsFeedbackDescription}>
                {translationString.global_result_strings.high.text_1}
              </p>
              <p className={classes.resultsFeedbackDescription}>
                {translationString.global_result_strings.high.text_2}
              </p>              
            </div>              
          : finalScore > 50 ? 
          <div>
            <div className={classes.resultsFeedback}>
              <span className={classes.resultsFeedbackHighlighted}>{translationString.global_result_strings.medium.label} {finalScore}%</span>{translationString.global_result_strings.medium.message} 
            </div>
            <p className={classes.resultsFeedbackDescription}>
              {translationString.global_result_strings.medium.text_1} 
            </p>
            <p className={classes.resultsFeedbackDescription}>
              {translationString.global_result_strings.medium.text_2} 
            </p>            
          </div>  
          : 
          <div>
            <div className={classes.resultsFeedback}>
              <span className={classes.resultsFeedbackHighlighted}>{translationString.global_result_strings.low.label} {finalScore}%</span>{translationString.global_result_strings.low.message}
            </div>
            <p className={classes.resultsFeedbackDescription}>
              {translationString.global_result_strings.low.text_1}
            </p>
            <p className={classes.resultsFeedbackDescription}>
            {translationString.global_result_strings.low.text_2}
            </p>            
          </div>  
        }  
      </Paper> 
      <Typography variant="h3" className={classes.subTitleResult}>
        {translationString.score_category}
      </Typography>              
      {processedAnswers.map((resultTopic, key) => (
        <Paper key={resultTopic.id} className={classes.paperResult}>
            <Typography variant="h2" className={classes.resultsTitle}>
              <div dangerouslySetInnerHTML={createMarkup(quizResults.results[key].topic_title)} />
            </Typography>
              <p className={classes.resultssubTitledescription} dangerouslySetInnerHTML={createMarkup(quizResults.results[key].topic_description)} />
              <p className={classes.resultssubTitledescription} dangerouslySetInnerHTML={createMarkup(quizResults.results[key].topic_subcategories)} />
            {resultTopic.topic_rate > 4.2 ? 
              <div>
                <div className={classes.resultsFeedback}>
                  <span className={classes.resultsFeedbackHighlighted}>{translationString.global_result_strings.high.label} {getPerc(resultTopic.topic_rate)}%</span>{translationString.global_result_strings.high.message}
                </div>
                <p className={classes.resultsFeedbackDescription} dangerouslySetInnerHTML={createMarkup(quizResults.results[key].topic_result_high)} />
              </div>              
            : resultTopic.topic_rate > 3 ? 
            <div>
              <div className={classes.resultsFeedback}>
                <span className={classes.resultsFeedbackHighlighted}>{translationString.global_result_strings.medium.label} {getPerc(resultTopic.topic_rate)}%</span>{translationString.global_result_strings.medium.message}
              </div>
              <p className={classes.resultsFeedbackDescription} dangerouslySetInnerHTML={createMarkup(quizResults.results[key].topic_result_high)} />
            </div>  
            : 
            <div>
              <div className={classes.resultsFeedback}>
                <span className={classes.resultsFeedbackHighlighted}>{translationString.global_result_strings.low.label} {getPerc(resultTopic.topic_rate)}%</span>{translationString.global_result_strings.low.message}
              </div>
              <p className={classes.resultsFeedbackDescription} dangerouslySetInnerHTML={createMarkup(quizResults.results[key].topic_result_high)} />
            </div>  
            }
        </Paper>
      ))}
    </div>
  )
};

export default TotalResults;
